import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const FinalCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const goMatrix = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (location.pathname === "/matrix") {
      const el = document.getElementById("matrix");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/matrix");
    }
  };

  return (
    <section className="py-12 md:py-20 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-primary/[0.06] blur-[140px] rounded-full pointer-events-none" />
      <div className="relative z-10 w-[90%] max-w-[820px] mx-auto text-center">
        <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-6xl">
          Still want it <span className="text-gold-gradient">back?</span>
        </h2>
        <p className="mt-5 font-display font-bold tracking-tight leading-tight text-xl sm:text-2xl md:text-[1.75rem] text-center" style={{ color: "#D4AF35" }} data-testid="final-cta-tagline">
          Look and feel like you again. Maybe even better.
        </p>
        <p className="mt-4 text-lg md:text-xl text-white/75 font-medium leading-relaxed max-w-xl mx-auto">
          Take the Matrix. Ninety seconds, and you'll know which of the seven systems are yours.
        </p>
        <button
          onClick={goMatrix}
          className="mt-9 inline-flex items-center rounded-full bg-primary text-primary-foreground font-bold text-base px-9 py-4 hover:brightness-110 active:scale-[0.98] transition focus-ring shadow-[0_12px_40px_-8px_rgba(212,175,55,0.6)]"
        >
          Take the Matrix (Free)
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
